// extracted by mini-css-extract-plugin
module.exports = {"audits":"admin-portal__PrescriptionAudits__audits","rightRow":"admin-portal__PrescriptionAudits__rightRow"};